/** Prev/next inside the *filtered* badge list, wrapping; null when the list is empty. */
export const nextBadgeId = (ids: number[], currentId: number, dir: 1 | -1): number | null => {
    if (ids.length === 0) return null
    const k = ids.indexOf(currentId)
    if (k < 0) return dir > 0 ? ids[0] : ids[ids.length - 1]
    return ids[(k + dir + ids.length) % ids.length]
}

/** Old e-mail/Slack links to the claim page now open the badge modal on /badges. */
export const legacyBadgeRequestTarget = (badgeId: string): string => `/badges#badge-${badgeId}`

/** Arrow keys belong to the field while typing; a checkbox/radio/button hands them to badge nav. */
export const isTextEntryTarget = (tagName: string | undefined, type: string | null): boolean => {
    if (tagName === 'TEXTAREA') return true
    if (tagName !== 'INPUT') return false
    return type !== 'checkbox' && type !== 'radio'
}
